import isEqual from 'lodash.isequal';
import omit from 'lodash.omit';
import {DEFAULT_ATTRIBUTE_DETAIL} from 'src/modules/event-create/attributes-block/constants';
import {CreationAttribute} from 'src/modules/event-create/typedefs';

export const isAttributeEmpty = (attribute: CreationAttribute) =>
    isEqual(omit(attribute, 'attributeId', 'eventId'), omit(DEFAULT_ATTRIBUTE_DETAIL, 'attributeId'));
